<template>
  <div class="toggler-theme">
    <slot />
    <div class="toggler-theme__wrap">
      <UiBadge
        class="toggler-theme__soon"
        background="solid"
        type="light"
        size="small"
        text="Скоро"
      />
      <UiTabs
        ref="tabsRef"
        :tabs="tabsList"
        :value="activeTab"
        :query="false"
        theme="lighten"
        size="s"
        @input="changeTab"
      />
    </div>
  </div>
</template>

<script>
import UiTabs from '@/components/ui/UiTabs'

export default {
  name: 'TogglerTheme',
  components: {
    UiTabs,
  },
  data() {
    return {
      activeTab: 'dark',
    }
  },
  computed: {
    tabsList() {
      return [
        {
          id: 'dark',
          title: this.$t('footer.themes.dark'),
          icon: 'themes/moon',
        },
        {
          id: 'light',
          title: this.$t('footer.themes.light'),
          icon: 'themes/sun',
        },
      ]
    },
  },
  methods: {
    changeTab(value) {
      this.activeTab = value
    },
    setLang(lang) {
      if (this.switchLocalePath(lang) === '') {
        this.$i18n.setLocale(lang)
      }
      this.$store.commit('user/setLang', lang)
    },
  },
}
</script>

<style lang="scss" scoped src="./style.scss"></style>
